import { render, staticRenderFns } from "./file-input-secondary.vue?vue&type=template&id=f159d792&scoped=true&"
import script from "./file-input-secondary.vue?vue&type=script&lang=js&"
export * from "./file-input-secondary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f159d792",
  null
  
)

export default component.exports